import { createFetcher } from './Fetcher';

export default createFetcher(({ userStore }) => ({
    fetch: userStore.fetchUser,
    isLoading: userStore.fetchUser.pending,
}));
